import api from '@/utils/api';

/**
 * Export customers
 * @param {string} query - Query to filter customers
 * @returns {Promise}
 */
const exportCustomersApi = (query) => {
  const url = query ? `customer/export?${query}` : 'customer/export';
  return api.get(url);
};

export default exportCustomersApi;
